import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AuthModule } from '../../../auth/auth.module';
import { B2BAngularMaterialModule } from '../angular.material/b2b.angular.material.module';
import { HelpDialogComponent } from './help.dialog.component';
import { NavigationComponent } from './navigation.component';

@NgModule({
    declarations: [NavigationComponent, HelpDialogComponent],
    entryComponents: [HelpDialogComponent],
    imports: [BrowserModule, RouterModule, FormsModule, AuthModule, B2BAngularMaterialModule],
    exports: [NavigationComponent]
})

export class NavigationModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/navigation/navigation.module.ts